import {ElementRef} from '@angular/core';
import {select as d3Select} from 'd3-selection';

export function cloneProductionScheduleElement(elementRef: ElementRef, productionScheduleElementPositionX: number): void {
  const productionScheduleElementSelection = d3Select(elementRef.nativeElement);
  productionScheduleElementSelection.node().classList.add('dragged-production-schedule-element');
  const productionScheduleElementNode: SVGGraphicsElement = productionScheduleElementSelection.node();
  const productionScheduleWrapper = d3Select('.production-schedule-builder-group');
  const productionScheduleWrapperElement: SVGGraphicsElement = productionScheduleWrapper.node() as SVGGraphicsElement;
  productionScheduleElementNode.parentNode.insertBefore(productionScheduleElementNode.cloneNode(true), productionScheduleElementNode.nextSibling);
  const productionScheduleElementClone = productionScheduleElementSelection.attr('x', productionScheduleElementPositionX).attr('class', 'production-schedule-element-clone');
  productionScheduleWrapperElement.appendChild(productionScheduleElementClone.node());
  productionScheduleElementClone.append('rect');
}
